import { useCallback, useMemo } from 'react';

import { getOrderReservations, type Order } from '@src/domains/orders';
import { useOrderDetails, useOrderDetailsHeader } from '@src/features/orders/details';
import { useVoucherDownload } from '@src/features/vouchers';

export function useConfirmedOrder(order: Order) {
  const { hasMultipleVouchers } = useOrderDetails(order);
  const { hasPendingVouchers } = useOrderDetailsHeader(order);
  const { download, isDownloading } = useVoucherDownload();

  const reservations = useMemo(() => getOrderReservations(order), [order]);

  const downloadOrder = useCallback(() => download({ kind: 'order', id: order.id }), [download, order.id]);

  return {
    reservations,
    hasMultipleVouchers,
    showsOrderDownload: reservations.length > 1,
    isOrderDownloadBlocked: hasPendingVouchers,
    isDownloadingOrder: isDownloading(order.id),
    downloadOrder,
  };
}

export default useConfirmedOrder;
